/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const SyslogEnum = {
    GET_POST_SYSLOG: '/syslog',
    GET_ALL_LOGS: (lines: string) => {
        return `/logs/?lines=${lines}`;
    },
    GET_LOG: (services: string[], since: string, until: string, reverse: boolean, lines: number): string => {
        let serviceString = '';

        for (const service of services) {
            const index = services.indexOf(service);
            serviceString = serviceString + `services[${index}]=${service}&`;
        }

        return `/logs/?${serviceString}since=${since}&until=${until}&lines=${lines}&reverse=${reverse}`;
    },
    GET_SERVICES: (): string => {
        return '/logs/services';
    }
};
